"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const Templates = require("./shared/Template/TemplateActions");
const Loader_1 = require("./shared/Loader");
const api_1 = require("./api");
const utils_1 = require("./utils");
exports.TimeAgo = new Loader_1.Library([], ["/vendor/jquery-timeago/jquery.timeago.js"]);
exports.DataTables = new Loader_1.Library(["/vendor/datatables-plugins/integration/bootstrap/3/dataTables.bootstrap.css", "/vendor/datatables-responsive/css/responsive.bootstrap.scss", "/vendor/datatables-select/css/select.bootstrap.scss"], ["/vendor/datatables/media/js/jquery.dataTables.js", "/vendor/datatables/media/js/dataTables.bootstrap.js", "/vendor/datatables-responsive/js/dataTables.responsive.js", "/vendor/datatables-select/js/dataTables.select.js"]);
exports.GalleryLib = new Loader_1.Library(["/css/gallery.css"], []);
exports.TemplatesLib = new Loader_1.Library(["/css/templates.css"], []);
exports.TemplateInit = new Loader_1.Library([], ["/js/sociareach.js"]);
exports.AdministrationInit = new Loader_1.Library(["/css/administration.css"], []);
exports.ReactSelect = new Loader_1.Library(["/vendor/react-select/dist/react-select.min.css"], ["/vendor/classnames/index.js", "/vendor/react-input-autosize/dist/react-input-autosize.min.js", "/vendor/react-select/dist/react-select.min.js"]);
exports.DateRangePicker = new Loader_1.Library(["/vendor/bootstrap-daterangepicker/daterangepicker.css"], []);
exports.TimePicker = new Loader_1.Library(["/css/rc-time-picker.css"], []);
exports.Ckeditor = new Loader_1.Library([], ["/vendor/ckeditor/ckeditor.js"]);
exports.CkeditorConfig = options => {
    return Object.assign({}, {
        removeButtons: "Image",
        allowedContent: true,
        extraPlugins: 'preview',
        toolbarGroups: [{ name: 'document' }, { name: 'clipboard', groups: ['clipboard', 'undo'] }, { name: 'links' }, { name: 'insert' }, { name: 'tools' }, '/', { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] }, { name: 'paragraph', groups: ['list', 'indent', 'align', 'colors'] }, '/', { name: 'styles' }, '/', { name: 'templates' }, { name: 'variables' }]
    }, options);
};
exports.CreateCkeditor = (element, businessId, options) => {
    const editor = CKEDITOR.replace(element, exports.CkeditorConfig(options));
    const config = editor.config;
    editor.on("configLoaded", eventInfo => {
        $("<div class='checkbox'><label><input type='checkbox' id='ckeditor-template-" + element + "' value='1' /> Save as new template</label></div>").insertBefore($("#" + element));
    });
    editor.on("saveTemplate", eventInfo => {
        if ($("#ckeditor-template-" + element).is(":checked")) {
            const templateContent = eventInfo.editor.getData();
            api_1.doPost(utils_1.RouteUtils.set(api_1.API.v1.TEMPLATES.ADD, { businessId: businessId }), {
                template: templateContent
            }).then(response => {}).catch(error => {
                api_1.handleError(error);
            });
        }
    });
    editor.addCommand("sociaReachTemplate", {
        exec: editor => {
            Templates.openTemplate(businessId, body => {
                editor.insertHtml(body);
            });
            return true;
        }
    });
    editor.ui.addButton("select_template", {
        label: 'Select template',
        command: "sociaReachTemplate",
        toolbar: "templates"
    });
    editor.ui.add('variables', CKEDITOR.UI_RICHCOMBO, {
        label: "Insert variable",
        title: "Insert variable",
        multiSelect: false,
        toolbar: "variables",
        className: "cke_variables",
        panel: {
            css: [CKEDITOR.getUrl('/vendor/ckeditor/skins/moono-lisa/editor.css'), config.contentsCss]
        },
        init: function () {
            TemplateVariables.forEach(variable => {
                this.add(variable[0], variable[1], variable[2]);
            });
        },
        onClick: function (value) {
            editor.focus();
            editor.fire("saveSnapshot");
            editor.insertText(value);
            editor.fire("saveSnapshot");
        }
    });
    return editor;
};
const TemplateVariables = [["${CUSTOMER_NAME}", "Customer name", "Customer name"], ["${BUSINESS_NAME}", "Business name", "Business name"], ["${BUSINESS_LOGO}", "Business logo", "Business logo"], ["${DATE}", "Send date", "Send date"], ["${VISIT_COUNT}", "Visit count", "Visit count"]];


//////////////////
// WEBPACK FOOTER
// ./client/src/libs.tsx
// module id = 1069
// module chunks = 0 1 2